import { useLocation } from 'react-router-dom';
import {
  CookbookFilterDataConnectorApollo,
  CookbookMealListConnectorApollo,
} from '@front-activerse/common-components';
import CookbookFilterContainer from './CookbookFilterContainer';

// Both queries start together: the screen renders as soon as the filter data arrives, while the
// full meal list keeps loading in the background and is only needed to show the results.
//
// SlideRoutes (destroy={false}) keeps this page mounted, so the filters would survive leaving it.
// Keying by the history entry resets them on every fresh visit from the cookbook (new entry, new
// key), while going back from the results restores the same entry and keeps the selection.
const CookbookFilterPage = () => {
  const location = useLocation();

  return (
    <CookbookFilterDataConnectorApollo>
      {(cookbookFilterData) => (
        <CookbookMealListConnectorApollo>
          {({ meals }) => (
            <CookbookFilterContainer {...cookbookFilterData} meals={meals} key={location.key} />
          )}
        </CookbookMealListConnectorApollo>
      )}
    </CookbookFilterDataConnectorApollo>
  );
};

export default CookbookFilterPage;
